import { Component, OnInit, Inject } from '@angular/core';
import {  MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-share-dialog',
  templateUrl: './share-dialog.component.html',
  styleUrls: ['./share-dialog.component.css']
})
export class ShareDialogComponent{

  constructor(public dialogRef: MatDialogRef<ShareDialogComponent>) { }

  fromName: string; // Qui envia el missatge
  toName: string; // A qui s'envia el missatge
  email: string; // Email de qui envia el missatge
  comment: string; // Comentari pel missatge
  closeDialog() {
    this.dialogRef.close({
      saved: false
    });
  }

  send() {
    this.dialogRef.close({
      saved: false,
    });

    

  }

}
